// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-event-cards-container"};